// eslint-disable-next-line unused-imports/no-unused-vars
export const themeColorGQLFields = (fields) => `
  key
  weights {
    key
    value
  }
`;
